import { Fancybox } from "@fancyapps/ui/src/Fancybox/Fancybox.js";

Fancybox.bind("[data-fancybox]", {
    Html: {
        youtube: {
            autoplay: 1
        }
    }
});

Fancybox.bind('.fancypopup', {
    type: 'ajax'
});
